import { apiSlice } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const serviceItemApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getServiceItems: builder.query({
      query: ({ companyId, tableFilterOutcomingData = {}, page = 1, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/service-item/get-all-service',
        method: 'POST',
        body: {
          company_id: companyId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        serviceItems: response?.serviceItems ?? [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['ServiceItems'],
    }),
    getServiceItemsByOperator: builder.query({
      query: ({ operatorId, tableFilterOutcomingData = {}, page = 1, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/service-item/get-all-service-by-operator',
        method: 'POST',
        body: {
          operator_id: operatorId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        serviceItems: response?.serviceItems ?? [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['ServiceItems'],
    }),
    deleteServiceItem: builder.mutation({
      query: (body) => ({
        url: '/service-item/delete-service-item',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'ServiceItems', 'Invoices', 'AccountCodeAmounts'],
    }),
    changeServiceStatus: builder.mutation({
      query: (body) => ({
        url: '/service-item/change-service-status',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'ServiceItems', 'Invoices', 'AccountCodeAmounts'],
    }),
    addServiceItem: builder.mutation({
      query: (body) => ({
        url: '/service-item/add-new-service',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'ServiceItems', 'Invoices', 'AccountCodeAmounts'],
    }),
    editServiceItem: builder.mutation({
      query: (body) => ({
        url: '/service-item/edit-service',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'ServiceItems', 'Invoices', 'AccountCodeAmounts'],
    }),
    getCalendarEvents: builder.query({
      query: ({ companyId, operatorId, role, dateFrom, dateTo, serviceTypeIds = [], performanceStatus = 'all' }) => ({
        url: '/service-item/get-calendar-events',
        method: 'POST',
        body: {
          company_id: companyId,
          // Only scope by operator_id for OPERATOR role — SUPER_ADMIN sees all company events
          ...(role === 'OPERATOR' && { operator_id: operatorId }),
          dateFrom,
          dateTo,
          serviceTypeIds,
          performanceStatus,
        },
      }),
      transformResponse: (response) => ({
        events: response?.events ?? [],
        stats: response?.stats ?? { total: 0, flights: 0, hotels: 0, visas: 0, other: 0, upcoming: 0 },
      }),
      providesTags: ['ServiceItems'],
    }),
  }),
});

export const {
  useGetServiceItemsQuery,
  useGetServiceItemsByOperatorQuery,
  useDeleteServiceItemMutation,
  useChangeServiceStatusMutation,
  useAddServiceItemMutation,
  useEditServiceItemMutation,
  useGetCalendarEventsQuery,
} = serviceItemApi;
